export default {
  computed: {
    accountId() {
      return this.$route.params.accountId;
    },
    // add request header, if we are in super-admin module
    requestHeaders() {
      if(!this.accountId) {
        return undefined;
      }
      return {
        "x-account-id": this.accountId
      };
    }
  }
};